import { log } from 'util';
import common from './common';
require('babel-polyfill')
// import layer from 'vue2-layer-mobile' //弹出层

// 配置API接口地址
//var root = 'https://bp.lzyunying.com'
var root = "";
if(common.env == 2){
    root = "https://fqyf.wts9999.net";
}

require('es6-promise').polyfill();
// 引用axios
var axios = require('axios')
// 自定义判断元素类型JS
function toType(obj) {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
    for (var key in o) {
        if (o[key] === null) {
            delete o[key]
        }
        if (toType(o[key]) === 'string') {
            o[key] = o[key].trim()
        } else if (toType(o[key]) === 'object') {
            o[key] = filterNull(o[key])
        } else if (toType(o[key]) === 'array') {
            o[key] = filterNull(o[key])
        }
    }
    return o
}
/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/

function apiAxios(method, url, params,success, failure) {
    if (params) {
        params = filterNull(params)
    }
    if(params.headers){
      params.headers = filterNull(params.headers)
    }
    var headers = params.headers
    delete params.headers
    var hideAlert = false;
    if(params.hideAlert){
        hideAlert = true;
        delete params.hideAlert;
    }
    axios({
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
        baseURL: root,
        withCredentials: true,
        headers: headers
    })
        .then(function (res) {
            if (success) {
                var isError = successError(res.data,hideAlert);
                success(res.data,isError)
            }

        })
        .catch(function (err) {
            let res = err.response
            if (res) {
                window.alert('api error, HTTP CODE: ' + res.status)
            }
        })
}
//公共错误处理
function successError(data,hideAlert) {
    if(data.httpCode == 200){
        return true
    }
    //服务器出错
    if (data.msg && !data.data) {
        setLayer(data.msg,hideAlert)
        return false;
    } else if (data.data.error) {
        setLayer(data.data.error.errMsg,hideAlert);
        return false;
    } else if (data.data.message) {
        setLayer(data.data.message,hideAlert);
        return false;
    } else if (data.data&&typeof data.data == "string") {
        setLayer(data.data,hideAlert);
        return false;
    }
    //服务器内部错误
    if (data.httpCode == 500) {
        setLayer("系统走神了，请稍后再试",hideAlert);
        return false;
    }
    return true
}

function setLayer(msg, hideAlert){
    if(hideAlert){
        return;
    }
    layer.open({
        content: msg
        ,skin: 'msg'
        ,styles: 'bottom:0;'
        ,time: 2 //2秒后自动关闭
    });
}
// 返回在vue模板中的调用接口
export default {
    get: function (url, params, success, failure) {
        return apiAxios('GET', url, params, success, failure)
    },
    post: function (url, params, success, failure) {
        return apiAxios('POST', url,params, success, failure)
    },
    put: function (url, params, success, failure) {
        return apiAxios('PUT', url, params, success, failure)
    },
    delete: function (url, params, success, failure) {
        return apiAxios('DELETE', url, params, success, failure)
    }
}



// WEBPACK FOOTER //
// ./src/api/ajax.js